// no baseURI

// object to store loaded and loading chunks
// undefined = chunk not loaded, null = chunk preloaded/prefetched
// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
var installedChunks = {
	"/js/main.script": 0,
	"components/base-icon/src/base-icon.scss": 0,
	"css/main.style": 0,
	"components/base-heading/src/base-heading.scss": 0,
	"components/base-divider/src/base-divider.scss": 0,
	"components/view-grid/src/view-grid.scss": 0,
	"components/user-display-name/src/user-display-name.scss": 0,
	"components/tiles-gallery/src/tiles-gallery.scss": 0,
	"components/tiles-gallery-item/src/tiles-gallery-item.scss": 0,
	"components/taxonomy-term/src/taxonomy-term.scss": 0,
	"components/social-media-list/src/social-media-list.scss": 0,
	"components/social-media-item/src/social-media-item.scss": 0,
	"components/base-body-text/src/base-body-text.scss": 0,
	"components/small-box/src/small-box.scss": 0,
	"components/search-page-link-block/src/search-page-link-block.scss": 0,
	"components/reference-content/src/reference-content.scss": 0,
	"components/product/src/product.scss": 0,
	"components/product-teaser/src/product-teaser.scss": 0,
	"components/product-gallery/src/product-gallery.scss": 0,
	"components/price-block/src/price-block.scss": 0,
	"components/paragraph-d-p-tiles/src/paragraph-d-p-tiles.scss": 0,
	"components/paragraph-d-p-single-text-block--side-by-side/src/paragraph-d-p-single-text-block--side-by-side.scss": 0,
	"components/paragraph-d-p-single-text-block--group/src/paragraph-d-p-single-text-block--group.scss": 0,
	"components/paragraph-d-p-side-tiles/src/paragraph-d-p-side-tiles.scss": 0,
	"components/paragraph-d-p-side-image/src/paragraph-d-p-side-image.scss": 0,
	"components/paragraph-d-p-side-embed/src/paragraph-d-p-side-embed.scss": 0,
	"components/paragraph-d-p-side-by-side/src/paragraph-d-p-side-by-side.scss": 0,
	"components/paragraph-d-p-reference-content/src/paragraph-d-p-reference-content.scss": 0,
	"components/paragraph-d-p-node/src/paragraph-d-p-node.scss": 0,
	"components/paragraph-d-p-group-of-text-blocks/src/paragraph-d-p-group-of-text-blocks.scss": 0,
	"components/paragraph-d-p-group-of-counters/src/paragraph-d-p-group-of-counters.scss": 0,
	"components/paragraph-d-p-gallery/src/paragraph-d-p-gallery.scss": 0,
	"components/paragraph-d-p-form/src/paragraph-d-p-form.scss": 0,
	"components/paragraph-d-p-counter/src/paragraph-d-p-counter.scss": 0,
	"components/paragraph-d-p-carousel/src/paragraph-d-p-carousel.scss": 0,
	"components/paragraph-d-p-carousel-item/src/paragraph-d-p-carousel-item.scss": 0,
	"components/paragraph-d-p-blog-text/src/paragraph-d-p-blog-text.scss": 0,
	"components/paragraph-d-p-blog-image/src/paragraph-d-p-blog-image.scss": 0,
	"components/paragraph-d-p-block/src/paragraph-d-p-block.scss": 0,
	"components/paragraph-d-p-banner/src/paragraph-d-p-banner.scss": 0,
	"components/pagination/src/pagination.scss": 0,
	"components/page/src/page.scss": 0,
	"components/page-views/src/page-views.scss": 0,
	"components/node--d-product--full/src/node--d-product--full.scss": 0,
	"components/navigation-mobile/src/navigation-mobile.scss": 0,
	"components/navigation-desktop/src/navigation-desktop.scss": 0,
	"components/navbar-brand/src/navbar-brand.scss": 0,
	"components/menu/src/menu.scss": 0,
	"components/menu-item/src/menu-item.scss": 0,
	"components/header/src/header.scss": 0,
	"components/hamburger/src/hamburger.scss": 0,
	"components/form/src/form.scss": 0,
	"components/footer-secondary/src/footer-secondary.scss": 0,
	"components/footer-primary/src/footer-primary.scss": 0,
	"components/footer-primary-column/src/footer-primary-column.scss": 0,
	"components/facets-result-item/src/facets-result-item.scss": 0,
	"components/d-p-text-paged/src/d-p-text-paged.scss": 0,
	"components/d-p-subscribe-file/src/d-p-subscribe-file.scss": 0,
	"components/d-p-subscribe-file-download-page/src/d-p-subscribe-file-download-page.scss": 0,
	"components/d-p-side-by-side-item/src/d-p-side-by-side-item.scss": 0,
	"components/cta-links/src/cta-links.scss": 0,
	"components/counter/src/counter.scss": 0,
	"components/carousel/src/carousel.scss": 0,
	"components/blog-teaser/src/blog-teaser.scss": 0,
	"components/blog-full/src/blog-full.scss": 0,
	"components/block-mobile-filters/src/block-mobile-filters.scss": 0,
	"components/block-mobile-filters-submit/src/block-mobile-filters-submit.scss": 0,
	"components/block-facets/src/block-facets.scss": 0,
	"components/block-exposed-filters/src/block-exposed-filters.scss": 0,
	"components/base-subtitle/src/base-subtitle.scss": 0,
	"components/base-overlay/src/base-overlay.scss": 0,
	"components/base-media/src/base-media.scss": 0,
	"components/base-media-icon/src/base-media-icon.scss": 0
};

// no chunk on demand loading

// no prefetching

// no preloaded

// no HMR

// no HMR manifest

__webpack_require__.O.j = function(chunkId) { return installedChunks[chunkId] === 0; };

// install a JSONP callback for chunk loading
var webpackJsonpCallback = function(parentChunkLoadingFunction, data) {
	var chunkIds = data[0];
	var moreModules = data[1];
	var runtime = data[2];
	// add "moreModules" to the modules object,
	// then flag all "chunkIds" as loaded and fire callback
	var moduleId, chunkId, i = 0;
	if(chunkIds.some(function(id) { return installedChunks[id] !== 0; })) {
		for(moduleId in moreModules) {
			if(__webpack_require__.o(moreModules, moduleId)) {
				__webpack_require__.m[moduleId] = moreModules[moduleId];
			}
		}
		if(runtime) var result = runtime(__webpack_require__);
	}
	if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
	for(;i < chunkIds.length; i++) {
		chunkId = chunkIds[i];
		if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
			installedChunks[chunkId][0]();
		}
		installedChunks[chunkId] = 0;
	}
	return __webpack_require__.O(result);
}

var chunkLoadingGlobal = self["webpackChunkDroopler_theme"] = self["webpackChunkDroopler_theme"] || [];
chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));